<template>
  <div class="systemPage">
    <p style="margin-bottom: 40px" class="title">
      <span>子系统权限</span>
    </p>
    <div>
      <div
        class="every-system"
        v-for="(item, index) in systemList"
        :key="'system_' + index"
      >
        <div class="system-box">
          <span class="system-name">{{ item.menuName }}</span>
          <img
            src="../assets/preview.png"
            style="width: 16px; height: 16px; margin-top: 28px; cursor: pointer"
            @click="previewSystem(item)"
          />
          <span
            style="
              margin-top: 28px;
              cursor: pointer;
              font-size: 12px;
              color: #409eff;
            "
            @click="previewSystem(item)"
            >详情</span
          >
        </div>
        <div style="line-height: 70px">
          <el-button
            type="text"
            class="right-btn"
            v-if="item.isManage"
            @click="shezhiSystem(item)"
            >去设置</el-button
          >
          <el-button type="text" class="right-btn" v-else style="color: #c0c4cc"
            >去设置</el-button
          >
        </div>
      </div>
    </div>

    <el-dialog
      title="子系统权限详情"
      :visible.sync="dialogVisible1"
      :modal-append-to-body="false"
      width="50%"
    >
      <div class="dialog-content">
        <!-- <span style="font-size: 72px">{{ formData }}</span> -->
        <el-tree
          ref="tree2"
          :data="menu"
          show-checkbox
          node-key="menuId"
          :props="defaultProps"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mytoken: "",
      defaultProps: {
        children: "children",
        label: "menuName",
        disabled:"menuName"
      },
      menuIds: [],
      menu: [],
      dialogVisible1: false,
      systemList: [],
      formData: "",
      myMenuId: "",
      manageUrl: "",
      userId: "",
    };
  },
  mounted() {
    let self = this;
    self.getDataList();
  },
  methods: {
    getmyInfo(info) {
      let self = this;
      setTimeout(function () {
        let url = info.manageUrl.slice(0, 28);
        self.userId = localStorage.getItem("gouserId");
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
          self.menuIds = JSON.parse(xhr.response).data.menues;
          self.$refs.tree2.setCheckedKeys(self.menuIds);
        };
        xhr.onerror = function () {
          console.log("请求出错");
        };
        // 发送异步 GET 请求
        xhr.open(
          "GET",
          `${url}/management/user/getInfoById?userId=${self.userId}`,
          true
        );
        xhr.setRequestHeader("Authorization", "Bearer " + self.mytoken);
        xhr.send();
        //第二个请求
        var xhr1 = new XMLHttpRequest();
        xhr1.onload = function () {
          // 输出接收到的文字数据
          self.menu = JSON.parse(xhr1.response).data;
          function disabledselecent(arr) {
            arr.forEach((item) => {
              item.disabled = true;
              if (item.children && item.children.length > 0) {
                disabledselecent(item.children);
              }
            });
          }
          // disabledselecent(self.menu);
          console.log(self.menu, "FF");
        };
        xhr1.onerror = function () {
          console.log("请求出错");
        };
        // 发送异步 GET 请求
        xhr1.open("GET", `${url}/management/menu/treeselect`, true);
        xhr1.setRequestHeader("Authorization", "Bearer " + self.mytoken);
        xhr1.send();
      }, 100);
    },
    getPower() {
      let self = this;
      let url = self.manageUrl.slice(0, 28);
      self.$http.get(
        url + "management/menu/list",
        {
          menuName: "",
          status: "",
        },
        function (response) {
          self.menu = response.data;
        },
        function (response) {
          //失败回调
        }
      );
    },
    getUserId() {
      let self = this;
      self.$http.get(
        // self.manageUrl,
        "http://192.168.0.131:8003/management/user/getInfoById",
        {
          userId: self.userId,
        },
        {
          headers: {
            Authorization: "Bearer " + "6bd28c0a4130456cbc78990ed0939719",
          },
        },
        function (response) {
          self.menuIds = response.data.menus;
          self.$refs.tree2.setCheckedKeys(self.menuIds);
          // self.getPower();
        },
        function (response) {
          //失败回调
        }
      );
    },
    //
    getDataList() {
      let self = this;
      let params = new FormData();

      self.$http.post(
        self.api.usersIndex,
        params,
        {},
        (res) => {
          if (res.code == 200) {
            if (res.body != "null" && res.body.zxtList) {
              self.myMenuId = res.body.zxtList[0].menuId;
              self.manageUrl = res.body.zxtList[0].manageUrlJson;

              let result = [];
              res.body.zxtList.forEach((item) => {
                result.push({
                  img: item.icon,
                  name: item.menuName,
                  show: item.isManage,
                  url: item.manageUrl,
                  detail: item.manageUrlJson,
                });
              });
              // self.systemList = result;
              self.systemList = res.body.zxtList;
            }
          }
        },
        (error) => {}
      );
    },
    shezhiSystem(item) {
      console.log(item);
      let userId = localStorage.getItem("gouserId");
      let self = this;
      self.$http.get(
        self.api.serviceToken + `?clientId=${item.menuId}&isChild=true`,
        {},
        function (response) {
          if (response.code == 200) {
            self.mytoken = response.body;
            if (item.manageUrl) {
              //当前页打开
              //location.href = item.manageUrl + `?serviceToken=${response.body}`;
              //新窗口打开
              window.open(
                item.manageUrl + `/${userId}?serviceToken=${response.body}`
              );
            } else {
              // location.href = item.indexUrl + `?serviceToken=${response.body}`;
              window.open(item.indexUrl + `?serviceToken=${response.body}`);
            }
          } else {
            self.$message({
              message: "你没有权限访问",
              type: "warning",
            });
            return false;
          }
        },
        function (response) {
          //失败回调
        }
      );
    },

    previewSystem(item) {
      let self = this;
      self.$http.get(
        self.api.serviceToken + `?clientId=${item.menuId}&isChild=true`,
        {},
        function (response) {
          if (response.code == "200") {
            self.mytoken = response.body;
            self.getmyInfo(item);
          }
        },
        function (response) {
          //失败回调
        }
      );
      this.formData = item.manageUrlJson;
      this.dialogVisible1 = true;
    },
  },
};
</script>

<style>
.dialog-content {
  height: 500px;
  overflow-y: auto;
  text-align: center;
}
.systemPage {
  height: 1439px;
  background-color: #fff;
  padding: 20px 52px 0;
}
.systemPage .title span {
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.systemPage .every-system {
  height: 82px;
  margin-bottom: 36px;
  display: flex;
}
.systemPage .every-system .system-box {
  width: 440px;
  height: 70px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
}
.systemPage .every-system .system-logo {
  width: 48px;
  height: 27px;
  margin-left: 14px;
  margin-top: 24px;
}
.systemPage .every-system .system-name {
  margin: 25px 19px 0 12px;
  font-size: 16px;
  font-weight: 600;
}
.systemPage .every-system .right-btn {
  font-size: 20px;
  font-weight: 600;
  margin-left: 22px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/sonSystem.vue